
import React from 'react'
import Finder from '../components/planfinder'
import Order from '../components/order'
import Grid from '@material-ui/core/Grid'
import { useOpenPlan } from '../redux/plan'


  const Manager = (props) => {
    const op = useOpenPlan()
    return (
      <div>
        <Grid container spacing={3}>
          <Grid item xs>
            <Finder /> 
          </Grid>
          {
            op ?
            <div>
              <Grid item xs>
                <Order />
              </Grid>
            </div> : <div></div>
          }
        </Grid>
      </div>
    )
  }
  
  export default Manager